import React, { Fragment, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Table from './Table';
import './Favorites.scss';
import { Helmet } from 'react-helmet';
import Layout from './../Layout';
import * as actions from './Favorites.actions';
import * as selectors from './Favorites.selectors';
import { stringifyEqualityCheck } from './../../utils';
import * as loginSelectors from './../Login/Login.selectors';

const Orders = (props) => {
    /* State to props */
    const favorites = useSelector(selectors.getFavorites, stringifyEqualityCheck);
    const fetching = useSelector(selectors.getFetching);
    const checking = useSelector(selectors.getChecking);
    const user = useSelector(loginSelectors.getUser, stringifyEqualityCheck);
    const cxmlData = useSelector(loginSelectors.getCxmlData, stringifyEqualityCheck);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const fetchFavorites = useCallback(() => dispatch(actions.fetchFavorites()), [dispatch]);
    const deleteFavorite = useCallback((id) => dispatch(actions.deleteFavorite(id)), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        fetchFavorites();
    }, [fetchFavorites]);

    return (
        <Layout
            title={<Fragment><i className="fas fa-shopping-cart" /> My Favorites</Fragment>}
            step={4}
            history={props.history}
        >
            <Helmet><title>My Favorites</title></Helmet>
            <div className="favorites-container">
                <h2>My Favorites</h2>
                <Table
                    favorites={favorites}
                    fetching={fetching}
                    checking={checking}
                    user={user}
                    cxmlData={cxmlData}
                    history={props.history}
                    deleteFavorite={deleteFavorite}
                />
            </div>
        </Layout>
    );
};

Orders.propTypes = {

};

export default Orders;
